// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useState, useEffect, useRef, useMemo} from 'react';
import {useLocation, useHistory, Redirect} from 'react-router-dom';
// @ts-ignore
import {renderRoutes, matchRoutes} from 'react-router-config';
import cn from 'classnames';
import www_util from 'hola_pub_util';
// @ts-ignore
import {Provider} from '../../../hola/pub/context.js';
import {Settings_context, Settings_provider}
    from '../../../hola/pub/settings_ctx';
import {Data_provider} from '../../../hola/pub/data_ctx';
import {Meta} from '../../../hola/pub/meta';
import {use_qs} from '../../../hola/pub/lib/use_qs';
import {Client_hints_provider} from '../../../hola/pub/client_hints';
import {Cookie_consent} from '../../../shared/ui/cookie_consent/cookie_consent';
import {Navbar_oculus} from '../ui/navbar/navbar';
import '../../../../www/hola/pub/css/components.less';
import './app.less';
import {Oculus_footer} from '../ui/footer/footer';
import oculus_theme
    from '../../../../www/hola/pub/css/core/oculus_theme.module.less';
import {Ga} from '../../../toolip/pub/ui/ga';
import {oculus_img_url} from '../../../hola/pub/ui/oculus_img_url';
import {AppContextProvider} from '../../../toolip/pub/lib/app_context';
import experiment_init from '../../../hola/pub/experiment_init';
import {Maintenance} from '../ui/common/maintenance';
// @ts-ignore
import cookie from 'cookie';
// @ts-ignore
import {fetch} from '/util/fetch.js';
import {use_persist_debug_param} from '../../../hola/pub/lib/debug';
import {get_aliased_pathname, get_pathname_for_redirect}
    from '../../../hola/pub/lib/use_pathname';
import etask from 'zetask';
import {type i_toast_config, Toast_container,
    Toast_provider} from '../../../shared/ui/toast';
import Icon_x from '../img/icons/24/close.svg';
import {Cms_switcher} from '../../../toolip/pub/ui/toolip/cms_switcher';
import {use_previous} from '../../../hola/pub/lib/use_previous';
import {static_resolvers} from '../cms_registry';

const toast_config: i_toast_config = {
    close_icon: <Icon_x/>,
};

const themes = {
    default: oculus_theme,
    oculus_theme: oculus_theme,
};

const r_or_call = v=>{
    if (typeof v=='function')
        return v();
    return v;
};

const nav_opt = {
    img_url_fn: oculus_img_url,
};
const route_opt = {
    default_theme: 'oculus',
    cp_link: '/dashboard',
    cp_after_login: true,
    footless: false,
};
const location_region_regex = /^\/proxy-location\/[^/]+\/[^/]+$/;
const location_only_regex = /^\/proxy-location\/[^/]+$/;
export const App = function App(props){
    const [client, set_client] = useState(false);
    const [cookie_ready, set_cookie_ready] = useState(false);
    const is_maintenance = experiment_init.ui_test?.test_maintenance;
    const history = useHistory();
    if (window)
    {
        // XXX dmitriiz: dirty hack: we have to send it to a lot places in
        // code
        // @ts-ignore
        window.react_history = history;
    }
    const {pathname: current_pathname} = useLocation();
    const pathname = get_aliased_pathname(current_pathname);
    const prev_current_pathname = use_previous(current_pathname);
    const pn_redirect = get_pathname_for_redirect(location.pathname);
    const init_path = useRef(pathname);
    const is_ssr_page = useRef(true);
    const navigated = useRef(false);
    const top_portal_ref = useRef();
    const navbar_portal_ref = useRef();
    const footer_portal_ref = useRef();
    const {routes} = props.route;
    const matched: any[] = matchRoutes(routes, pathname) || [];
    const silent_state = useMemo(()=>{
        return {path: matched && matched[0] && matched[0].route.path};
    }, []);
    const [app_settings, set_app_settings] = useState({
        edit_mode: false,
        overrides: {...props.overrides},
        meta: {...props.meta_overrides},
        resolvers: static_resolvers,
        create_content: (pn, conf)=>etask(function*(){
            yield fetch(`/cms/create_content?path=${
                encodeURIComponent(pn)
            }`, {
                method: 'POST',
                json: true,
                body: {
                    override: conf.override,
                    meta: conf.meta,
                },
            });
        }),
        save_overrides: (pn, conf, just_state?)=>{
            set_app_settings(app_s=>({
                ...app_s,
                overrides: {
                    ...app_s.overrides,
                    [pn]: conf,
                },
            }));
            if (conf.loading || conf.error || just_state)
                return;
            fetch(`/cms/save_overrides?path=${
                encodeURIComponent(pn)
            }`, {
                method: 'POST',
                json: true,
                body: {
                    override: conf,
                },
            });
        },
        save_meta: (pn, conf, just_state?)=>{
            set_app_settings(app_s=>({
                ...app_s,
                meta: {
                    ...app_s.meta,
                    [pn]: conf,
                },
            }));
            if (conf.loading || conf.error || just_state)
                return;
            fetch(`/cms/save_meta?path=${
                encodeURIComponent(pn)
            }`, {
                method: 'POST',
                json: true,
                body: {
                    meta: conf,
                },
            });
        },
        delete_content: pn=>etask(function*(){
            if (!pn)
                return {status: 'error', message: 'Missing path'};
            try {
                const res = yield fetch(`/cms/delete_content`, {
                    method: 'POST',
                    json: true,
                    body: {path: pn},
                });
                return res;
            } catch(e){
                console.error('delete_content failed', e);
                return {status: 'error', message: e.message};
            }
        }),
        toggle_article_visibility: (pn, is_public)=>etask(function*(){
            try {
                const result = yield fetch(`/cms/toggle_article_visibility`, {
                    method: 'POST',
                    json: true,
                    body: {path: pn, public: is_public},
                });
                if (result?.status == 'ok' && result.overrides)
                {
                    set_app_settings(app_s=>({
                    ...app_s,
                    overrides: {...app_s.overrides, [pn]: result.overrides},
                }));
                }
                return result;
            } catch(e){
                console.error('toggle_article_visibility failed', e);
                throw e;
            }
        }),
    });
    use_persist_debug_param();
    useEffect(()=>{
        if (props.user && cookie.get('need_unsubscibe'))
        {
            cookie.remove('need_unsubscibe', {domain: `.${location.host}`,
                path: '/'});
            fetch('/users/set_email_unsubscribe', {
                method: 'POST',
                body: {email: props.user.emails[0].value, value: true},
            });
        }
    }, []);
    useEffect(()=>{
        const path = matched && matched[0] && matched[0].route.path;
        if (navigated.current && history.action!='POP')
        {
            if (silent_state.path!=path)
            {
                // @ts-ignore
                window.scroll({top: 0, behavior: 'instant'});
            }
        }
        else
            navigated.current = true;
        silent_state.path = path;
    }, [pathname]);
    useEffect(()=>{
        if (app_settings.overrides[pathname]
        && (prev_current_pathname &&
        current_pathname === prev_current_pathname))
        {
            return;
        }
        app_settings.save_overrides(pathname, {loading: true}, true);
        etask(function*(){
            const overrides = yield fetch(`/cms/get_overrides?path=${
                encodeURIComponent(pathname)
            }&reqp=${encodeURIComponent(current_pathname)}`);
            if (overrides && overrides.status=='ok')
            {
                app_settings.save_overrides(pathname, overrides.overrides,
                    true);
                app_settings.save_meta(pathname, overrides.meta, true);
            }
            else
                app_settings.save_overrides(pathname, {error: true}, true);
        });
    }, [pathname, current_pathname, prev_current_pathname, app_settings]);
    useEffect(()=>{
        // @ts-ignore
        history.block(()=>www_util.before_spa());
        // @ts-ignore
        if (window.postponed_js)
        {
            setTimeout(()=>{
                // @ts-ignore
                window.postponed_js.forEach(js=>{
                    const s_el = document.createElement('script');
                    s_el.src = js;
                    // @ts-ignore
                    s_el.onerror = function(){ window.handle_fallback(this); };
                    document.head.appendChild(s_el);
                });
            }, 0);
        }
        set_client(true);
    }, []);
    const route_props = Object.assign({top_portal_ref, navbar_portal_ref,
        footer_portal_ref}, props);
    if (route_props.location)
        route_props.location = {...route_props.location, pathname: pathname};
    const [reload, set_reload] = useState(1);
    useEffect(()=>{
        if (matched[0].route && !matched[0].route.loaded)
        {
            matched[0].route.on_load = ()=>{
                set_reload(r=>r+1);
                matched[0].route.on_load = undefined;
            };
        }
    }, [matched[0].route && matched[0].route.loaded]);
    const headless = matched.every(({route})=>r_or_call(route.headless));
    const footless = matched.every(({route})=>r_or_call(route.footless));
    const hide_cta =
        matched.every(({route})=>r_or_call(route.footer_opt?.hide_cta));
    const qs = use_qs();
    const {route} = matched && matched[0] || {};
    const _host = props.host && props.host.replace(/\./g, '_');
    const _page = pathname.slice(1).replace(/\//g, '_')||'homepage';
    const wrapper_cls = useMemo(()=>{
        if (is_ssr_page.current && pathname!==init_path.current)
            is_ssr_page.current = false;
        return cn(props.host && `host-${_host}`, `page-${_page}`, {
            client,
            ssr_page: is_ssr_page.current,
        });
    }, [props.host, _host, _page, qs.no_animation, client]);
    useEffect(()=>{
        if (!route.click_tracking)
            return;
        const host = route.click_host || _host;
        const handle_click = event=>{
            const {id, info} = www_util.get_click_data(event.target);
            if (id)
            {
                const perr_id = `www_click_${host||'unknown_host'}_${id}`;
                www_util.perr({id: perr_id, info, build: {pathname}});
            }
        };
        document.addEventListener('click', handle_click);
        return ()=>document.removeEventListener('click', handle_click);
    }, [_page]);
    const def_keywords = 'proxy, proxies, free proxy pool, cheap, ISP, '+
        'datacenter proxies, API, residential proxy.';
    const def_description = 'Oculus - Get affordable premium proxies. '+
        'Enjoy high-speed, reliable, and secure proxy services tailored to '+
        'your needs. Free trial.';
    let switch_opt = {location: {...props.location}};
    switch_opt.location.pathname = pathname;
    const is_main_location = current_pathname.includes(':');
    const is_location = current_pathname.includes('proxy-location');
    const is_location_region = location_region_regex.test(current_pathname);
    const is_location_default = location_only_regex.test(current_pathname);

    const toggle_edit_mode =()=>
    etask(function*(){
        const override_pathname = pathname.includes(':')
                ? current_pathname : pathname;
        if (!is_main_location && !app_settings.overrides[override_pathname])
        {
            yield app_settings.create_content(`/empty${current_pathname}`, {
                override: app_settings.overrides[pathname],
                meta: {
                    meta: {
                        robots: 'noindex,nofollow',
                        ...app_settings.meta[pathname]?.meta
                    },
                    url: current_pathname,
                }
            });
            window.location.reload();
            return;
        }
        return set_app_settings(prev=>({
            ...prev,
            edit_mode: !prev.edit_mode
        }));
    });
    const toggle_edit_mode_secondary =()=>{
        if (app_settings.edit_mode)
        {
            set_app_settings(prev=>({...prev, edit_mode: !prev.edit_mode}));
            history.goBack();
            return;
        }
        if (is_location_region)
        {
            history.push('/proxy-location/:location/:region');
            set_app_settings(prev=>({...prev, edit_mode: !prev.edit_mode}));
            return;
        }
        if (is_location_default)
        {
            history.push('/proxy-location/:location');
            set_app_settings(prev=>({...prev, edit_mode: !prev.edit_mode}));
            return;
        }
        set_app_settings(prev=>({...prev, edit_mode: !prev.edit_mode}));
    };
    if (pn_redirect)
        return <Redirect to={pn_redirect}/>;
    return <Data_provider {...props} route={route}>
      <Provider {...props} headless={headless}>
        <Settings_provider {...props} location={window.location} route={route}
          app_default_theme={'oculus'} themes_add={themes}
          app_settings={app_settings} set_app_settings={set_app_settings}>
          <Meta props={props} routes={routes} matched={matched}
            def_keywords={def_keywords} def_description={def_description}
            overrided_meta={app_settings?.meta?.[pathname]}>
            <Client_hints_provider {...props}>
              <AppContextProvider>
                  <Toast_provider config={toast_config}>
                    <Settings_context.Consumer>
                    {value=><div id={'page_content_wrapper'} key={reload}
                      className={cn(wrapper_cls, value.theme.root)}>
                      <Ga />
                      <Navbar_oculus {...props} headlogo={is_maintenance}
                        route={route} nav_opt={nav_opt} route_opt={route_opt}/>
                      {is_maintenance ? <Maintenance /> :
                        renderRoutes(routes, route_props, switch_opt)}
                      {!cookie_ready && !props.cookie_value ?
                        <Cookie_consent is_oculus on_apply={()=>{
                          set_cookie_ready(true);
                        }} cookie_name={'allow_oculus_cookie'}/> : null}
                      {!footless && !is_maintenance &&
                        <Oculus_footer hide_cta={hide_cta}/>}
                      <Toast_container/>
                      {!is_main_location && <Cms_switcher
                        caption={!app_settings.edit_mode ? 'Open CMS' :
                          'Close CMS'}
                        on_click={toggle_edit_mode}/>}
                      {is_location && <Cms_switcher
                        caption={!app_settings.edit_mode ?
                          'Open CMS (:location)' : 'Close CMS (:location)'}
                        on_click={toggle_edit_mode_secondary}
                        secondary/>}
                    </div>}
                    </Settings_context.Consumer>
                  </Toast_provider>
                </AppContextProvider>
            </Client_hints_provider>
          </Meta>
        </Settings_provider>
      </Provider>
    </Data_provider>;
};
